"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "UserProfileModerationContainer", {
  enumerable: true,
  get: function get() {
    return _UserProfileModerationContainer.default;
  }
});
Object.defineProperty(exports, "UserProfileModerationPanelBody", {
  enumerable: true,
  get: function get() {
    return _UserProfileModerationPanel.UserProfileModerationPanelBody;
  }
});
Object.defineProperty(exports, "UserProfileModerationPanelHeader", {
  enumerable: true,
  get: function get() {
    return _UserProfileModerationPanel.UserProfileModerationPanelHeader;
  }
});
exports.default = void 0;
Object.defineProperty(exports, "toggleUserProfileModeration", {
  enumerable: true,
  get: function get() {
    return _userProfileModeration.toggleUserProfileModeration;
  }
});

var _UserProfileModerationContainer = _interopRequireDefault(require("./UserProfileModerationContainer"));

var _UserProfileModerationPanel = require("./UserProfileModerationPanel");

var _userProfileModeration = require("./userProfileModeration.service");

var _default = _UserProfileModerationContainer.default;
exports.default = _default;